export const currentShiftDepotServerModel = depot => ({
    depotId: depot.depotId,
    courierIds: depot.courierIds
})

